module.exports = __webpack_public_path__ + "static/media/waiting.7c2a246e.svg";